<template>
  <div id="product" class="main">
    <ProductHead :img="item.BANNER"
      :title="item.PRONAME"
      :sub="item.EN"
      :products="item.PRODUCTS"
      :weight="item.WEIGHT" />

    <!-- Top -->
    <ProductTop ref="productTop"
      :flavor="item.FLAVOR"
      :packing="item.PACKING"
      :imgs="imgs" />

    <div class="color-change">
      <div class="wrap-1280">
        <div class="title ft-30">{{ item.PRONAME }}</div>
        <div class="line"></div>
        <div class="detail ft-14" v-html="item.CONTENT"></div>
        <div class="btn-wrap">
          <Morebtn :dark="true"
            :text="$t('btn3')"
            @btn-click="gotoFatherPage" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductHead from '@/components/ProductHead.vue'
import ProductTop from '@/components/ProductTop.vue'
import Morebtn from '@/components/Morebtn.vue'
import { getProductUrl, getProductSwiperUrl } from '@/util/url.js'
import axios from 'axios'

export default {
  components: {
    ProductHead,
    ProductTop,
    Morebtn
  },

  data () {
    return {
      imgs: [],
      item: {
        ID: '-1',
        BANNER: '/images/vacances-en-laponie-en-hiver-707.jpg',
        PRONAME: '',
        EN: '',
        PRODUCTS: '',
        WEIGHT: '',
        FLAVOR: '',
        PACKING: '',
        CONTENT: ''
      }
    }
  },

  mounted () {
    document.title = `${this.$t('nav.products')}-${this.$t('title')}`
    this.fechData()

    this.$nextTick(() => {
      if (window.scrollBar) window.scrollBar.scrollTop = 0

      // setTimeout(() => {
      //   this.loader.hide()
      // }, 300)
    })
  },

  methods: {
    fechData () {
      const id = this.$route.params.id

      const url0 = getProductSwiperUrl(id)
      axios.get(url0).then(res => {
        if (res && res.data && res.data.length > 0) {
          this.imgs = res.data
          this.$nextTick(() => {
            this.$refs.productTop.init()
          })
        }
      })

      const url = getProductUrl(id)
      axios.get(url).then(res => {
        if (res && res.data && res.data.proarr) {
          this.item = res.data.proarr
        }
      })
    },

    gotoFatherPage () {
      const fid = this.$route.params.fid
      this.$router.push(`/products/${fid}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.main, .color-change {
  background: linear-gradient(#cae6f9, #cae6f9, #fff);
}

.wrap-1280 {
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
  padding: 300px 30px 30px 30px;

  .title {
    text-align: center;
    line-height: 100px;
  }
  .line {
    height: 1px;
    background-color: #ddd;
  }
  .detail {
    margin: 100px 0;
    line-height: 32px;
  }
  .btn-wrap {
    display: flex;
    justify-content: center;
  }
}

</style>
